//scroll variable to track window's scroll
var lastScrollTop = 0;
var mobileW = 0;

//vanilla variables for resizing 
var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

//header image to be window height on homepage
if(document.getElementsByClassName('img-slide').length > 0){
	let headerImages = document.getElementsByClassName('img-slide');
	let headerImagesLength = headerImages.length;
	for(let i = 0; i < headerImagesLength; i++){
		headerImages[i].style.height = (windowHeight + 10) + 'px';
	}
}
resizeWindow();


// Func = limiting Scope for this file
(function(){
	$(document).ready(function () {
		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(0);
			}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(0);
		});
		$('ul.submenu').parent().addClass("sub-menu-li");

		//click menu
		$("#btn-menu-js").click(function(){
			$(".menu-block").addClass("active");
		});
		$(".menu-block__close").click(function(){
			$(".menu-block").removeClass("active");
		});

		// click booking
		$("#booking-menu-js").click(function(){
			$("#booking-block").addClass("active");
			$("#header").addClass("open-booking");
		});
		$("#booking-close-js").click(function(){
			$("#booking-block").removeClass("active");
			$("#header").removeClass("open-booking");
		});

		//hover Menu
		var currentMenuItem = $("#privary-navigation a.active").parent().index();
		$(".menu-hovers .slide:eq(" + currentMenuItem + ")").addClass("active");
		$("#privary-navigation > .privary-navigation__item > a").hover(function () {
			var hoverItem = $(this).parent().index();
			$(".menu-hovers .slide").removeClass('active');
			$(".menu-hovers .slide:eq(" + hoverItem + ")").addClass("active");
		});

		//mobile burger menu
		$("#burgerMenu").click(function () {
			$('#mobile-menu').addClass('open');
		});
		$("#mobile-close-js").click(function () {
			$('#mobile-menu').removeClass('open');
		});
		//SUBNAVIGATION

		// Open active sub-nav on load
		$('.navigation ul.submenu li .active').closest('.inner').addClass('open')
		$('.navigation ul.submenu li .active').parents().parents('li').addClass('item-open');
		$('.navigation ul.submenu li .active').closest('.sub-sub-menu').slideDown(300, function () { }).addClass('menu-open');

		$(".submenu__label, .sub-menu-mobile li").on("click", function(e){
			$(".sub-menu").slideToggle();
		});	

		//Toggle open/close on tap
		$('.navigation li a').off('click').on('click', function (event) {
			if ($(this).parent().children(".sub-sub-menu").length > 0) {

				event.preventDefault();

				if ($(this).next().hasClass('menu-open')) {
					$(this).closest('.inner').removeClass('open');
					$('.navigation ul li').removeClass('item-open');
					$(this).parent().addClass('item-open');
					$(this).next().slideUp(300, function () {
						if ($('.navigation ul li a').hasClass('active')) {
							$(".item-open").get(0).scrollIntoView(false);
						}
					}).removeClass('menu-open');
				} else {
					$(this).closest('.inner').addClass('open');
					$('.navigation ul li').removeClass('item-open');
					$(this).parent().addClass('item-open');
					$('.sub-sub-menu.menu-open').slideUp(300).removeClass('menu-open');
					$(this).next().addClass('menu-open').slideDown(300, function () {
						if ($('.navigation ul li a').hasClass('active')) {
							$(".item-open").get(0).scrollIntoView(false);
						}
					});
				}
			}
		});
		
		//placehorder for input date mobile
		$("input[type=date],input[type=time]").on("input", function () {
			if ($(this).val().length > 0) {
			  $(this).addClass("full");
			} else {
			  $(this).removeClass("full");
			}
		  });
		
		const playvideo = document.querySelector(".videoplay")
		if (playvideo != null) {
			playvideo.addEventListener("click", ()=>{
				const video = document.querySelector(".top-content__video video");
				if (video.paused) {
					video.play();
					playvideo.classList.remove("play")
				} else {
					video.pause();
					playvideo.classList.add("play")
				}
			})
		}
		
		const audiovideo = document.querySelector(".videoaudio")
		if (audiovideo != null) {
			audiovideo.addEventListener("click", ()=>{
				const video = document.querySelector(".top-content__video video");
				if (video.muted) {
					video.muted = false;
					audiovideo.classList.add("unmuted")
				} else {
					video.muted = true;
					audiovideo.classList.remove("unmuted")
				}
			})
		}

	}());
	
	window.onload = function() {
		resizeWindow();
		scrollW();
	};

	window.addEventListener('scroll', function(){
		scrollW();
	})
	window.addEventListener('resize', function(){
		resizeWindow();
	});
	
	
	// SPLIT CURSIVE TITLE TEXT
	document.querySelectorAll('figcaption , .quad-full-image__sentence, .cite-block__copy > p').forEach(span => {
		const chars = span.textContent.split('').map(char => `<span class="char">${char}</span>`).join('');
		span.innerHTML = chars;
	});

}());

// table section
const tablesResp = document.querySelectorAll('.text-modules table, .text table');
if(tablesResp.length){
	tablesResp.forEach( tablei=>{
		var tableresponsive = document.createElement('div');
		tableresponsive.classList.add('tableHold');
		tablei.parentNode.insertBefore( tableresponsive, tablei);
		tableresponsive.append(tablei);
		const ths = tablei.querySelectorAll('tr:first-child > *');
		tablei.querySelectorAll('tr + tr').forEach( (row)=>{
			const tds = row.querySelectorAll('td');
			let i = 0;
			for( i; i < tds.length; i++){
				tds[i].setAttribute('data-label', ths[i].textContent);
			}
		});
		const rowHeads = tablei.querySelectorAll('tr td:first-child');
		rowHeads.forEach( ele=>{
			ele.addEventListener('click',(ev)=>{
				ele.closest('tr').classList.toggle('active');
			})
		})
	});

}


function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			
		  
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	
}

function resizeWindow(){
	//calculate a new window size
	windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
	windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

	//header image to be window height on homepage
	if(document.getElementsByClassName('img-slide').length > 0){
		let headerImages = document.getElementsByClassName('img-slide');
		let headerImagesLength = headerImages.length;
		for(let i = 0; i < headerImagesLength; i++){
			headerImages[i].style.height = (windowHeight + 10) + 'px';
		}
	}
	
	
}

//animation of scroll vanilla JS
function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}


// Animation on the LP /montego-bay-tennis, on the first CTA Book Now.
const formtennis = document.getElementById('btn_to-formRFP');
if (formtennis) {
	formtennis.addEventListener('click',(event) => {
		event.preventDefault();
		animateTo('form_id-2701');
	});
}